export function getPrettyName(environment: string): string {
  switch (environment) {
    case 'import.io':
      return 'Production';
    case 'demo-owl.com':
      return 'Demo';
    case 'staging-owl.com':
      return 'Staging';
    default:
      return '';
  }
}
